import { useState } from 'react';
import styles from '../App.module.css';
import api from '../api/axios';
import { FaPencilAlt, FaTrashAlt, FaCheck, FaTimes, FaExclamation } from 'react-icons/fa';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import '../css/notifications.css';
import { useEffect } from 'react';
import notifications from '../components/notifications';

function Parceiros() {

  const [notificationType, setNotificationType] = useState(0);

  const [nomeParceiro, setNomeParceiro] = useState("");
  const [contatoParceiro, setContatoParceiro] = useState("");
  const [cpfParceiro, setCpfParceiro] = useState("");
  const [pixParceiro, setPixParceiro] = useState("");
  const [usuarioParceiro, setUsuarioParceiro] = useState("");
  const [obsParceiro, setObsParceiro] = useState("");
  const [vendaTotalParceiro, setVendaTotalParceiro] = useState("0");
  const [vendaPagaParceiro, setVendaPagaParceiro] = useState("0");
  const [statusParceiro, setStatusParceiro] = useState("0");

  const [comprovanteNomeParceiro, setComprovanteNomeParceiro] = useState("");
  const [comprovanteContatoParceiro, setComprovanteContatoParceiro] = useState("");
  const [comprovanteCpfParceiro, setComprovanteCpfParceiro] = useState("");
  const [comprovantePixParceiro, setComprovantePixParceiro] = useState("");
  const [comprovanteUsuarioParceiro, setComprovanteUsuarioParceiro] = useState("");
  const [comprovanteObsParceiro, setComprovanteObsParceiro] = useState("");
  const [comprovanteVendaTotalParceiro, setComprovanteVendaTotalParceiro] = useState("");
  const [comprovanteVendaPagaParceiro, setComprovanteVendaPagaParceiro] = useState("");
  const [comprovanteStatusParceiro, setComprovanteStatusParceiro] = useState("");

  const [usersListParceiros, setUsersListParceiros] = useState([]);
  const [comprovanteEnviadoParceiros, setComprovanteEnviadoParceiros] = useState(false);
  const [filteredDataParceiros, setFilteredDataParceiros] = useState([]);

  useEffect(() => {
    async function getUsers() {
      const resParceiros = await api.get('/clientesParceiros');
      setUsersListParceiros(resParceiros.data);
      setFilteredDataParceiros(resParceiros.data);
    }
    getUsers();
  }, []);
  async function getUsers() {
    const resParceiros = await api.get('/parceiros');
    setUsersListParceiros(resParceiros.dataParceiros);
  }
  const deleteUserParceiros = async (id) => {
    const res = await api.post('/deletarParceiros', {
      id: id
    });
    if (res.data === true) {
      const newItems = usersListParceiros.filter(item => item.id !== id);
      setUsersListParceiros(newItems);
      setNotificationType(4);
    } else {
      setNotificationType(5);
    }
  }
  /* Notificações Customizadas */
  useEffect(() => {
    if (notificationType && notifications[notificationType]) {
      notifications[notificationType]();
      setNotificationType(0);
    }
  }, [notificationType]);
  /* Faz a verificação de todos os campos para saber se estão vazios ou preenchidos. */
  const validateFormParceiros = () => {
    if (nomeParceiro === "" ||  usuarioParceiro === "") {
      // if (login === "" || senha === "" || conta === "" || cidade.length === 0 || anoMarcado === "" || mesMarcado === "" || diaMarcado === "" || anoBloqueado === "" || mesBloqueado === "" || diaBloqueado === "" || grupo === "") {
      return false;
    }
    return true;
  }

  /* Insere os dados somente se todos os campos requeridos estiverem preenchidos. */
  const insertDataParceiros = async () => {
    if (validateFormParceiros() === true) {
      const res = await api.post('/cadastrarParceiros', {
        nomeParceiro,
        contatoParceiro,
        cpfParceiro,
        pixParceiro,
        usuarioParceiro,
        obsParceiro,
        vendaTotalParceiro,
        vendaPagaParceiro,
        statusParceiro
      });
      if (res.data.status === true) {
        const newUser = {
          id: res.data.insertId,
          nomeParceiro: nomeParceiro,
          contatoParceiro: contatoParceiro,
          cpfParceiro: cpfParceiro,
          pixParceiro: pixParceiro,
          usuarioParceiro: usuarioParceiro,
          obsParceiro: obsParceiro,
          vendaTotalParceiro: vendaTotalParceiro,
          vendaPagaParceiro: vendaPagaParceiro,
          statusParceiro: 0
        }
        // setUsersListProd([...usersListProd, newUser]);
        setNotificationType(1);
        clearDataParceiros();
        setComprovanteEnviadoParceiros(true)
        setComprovanteNomeParceiro(nomeParceiro)
        setComprovanteContatoParceiro(contatoParceiro)
        setComprovanteCpfParceiro(cpfParceiro)
        setComprovantePixParceiro(pixParceiro)
        setComprovanteUsuarioParceiro(usuarioParceiro)
        setComprovanteObsParceiro(obsParceiro)
        setComprovanteVendaTotalParceiro(vendaTotalParceiro)
        setComprovanteVendaPagaParceiro(vendaPagaParceiro)
        setComprovanteStatusParceiro(statusParceiro)
      } else {
        setNotificationType(2);
      }
    } else {
      setNotificationType(3);
    }
  }
  /* Limpa todos os campos após cadastro ser realizado com sucesso! */
  const clearDataParceiros = () => {
    setNomeParceiro("");
    setContatoParceiro("");
    setCpfParceiro("");
    setPixParceiro("");
    setUsuarioParceiro("");
    setObsParceiro("");
    setVendaTotalParceiro(0);
    setVendaPagaParceiro(0);
    setStatusParceiro(0)
    console.log("limpou")
  }

  function copyTextToClipboard(text) {
    const input = document.createElement('input');
    input.setAttribute('value', text);
    document.body.appendChild(input);
    input.select();
    document.execCommand('copy');
    document.body.removeChild(input);
  }
  return (
    <div className={styles.app}>
      <NotificationContainer />

      <div className={`${styles.corTitulo} ${styles.green}`}>
        <p className={styles.titulo}>PROGRAMA DE PARCEIROS</p>
      </div>
      <div className={styles.cadastroClienteContainer}>
        {/* Parte 01 cadastro */}
        <div className={styles.containerTituloInput} style={{ marginTop: '20px', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px', marginBotton: '20px' }}>
          {/* <p className={styles.titulo}>PRODUÇÃO!!</p> */}
          <input className={styles.inputStyleLogin} type="text" onChange={(e) => setNomeParceiro(e.target.value)} value={nomeParceiro} placeholder="Nome do parceiro:" />
          <input className={styles.inputStyleLogin} type="text" onChange={(e) => setContatoParceiro(e.target.value)} value={contatoParceiro} placeholder="Digite o contato: +55 61 99601-1975" />
          <input className={styles.inputStyleLogin} type="text" onChange={(e) => setCpfParceiro(e.target.value)} value={cpfParceiro} placeholder="Digite o CPF" />
          <input className={styles.inputStyleLogin} type="text" onChange={(e) => setPixParceiro(e.target.value)} value={pixParceiro} placeholder="Digite a chave PIX" />
          <input className={styles.inputStyleLogin} type="text" onChange={(e) => setUsuarioParceiro(e.target.value)} value={usuarioParceiro} placeholder="Nome de usuário" />
        </div>
        <div className={styles.containerVendedorInput}>
          {/* Parte 03 cadastro */}
          <div className={styles.divisor}></div>
          <div className={styles.cadastroItems04}>
            <div className={styles.itemContainer}>
              {/* <p className={styles.inputText}>Observações:</p> */}
              <textarea onChange={(e) => setObsParceiro(e.target.value)} value={obsParceiro} className={styles.textArea} placeholder="Deixe uma observação sobre o parceiro" ></textarea>
            </div>
          </div>
          <div className={styles.buttonContainer}>
            <button onClick={() => {
              setStatusParceiro(0);
              setVendaTotalParceiro(0);
              setVendaPagaParceiro(0);
              insertDataParceiros();
            }} className={styles.cadastroCliente}>
              CADASTRAR
            </button>
          </div>
        </div>
        {comprovanteEnviadoParceiros === true ?
          <div className={`${styles.cadastroClienteContainer} ${styles.copiar}`}
            onClick={() => {
              var r = document.createRange();
              r.selectNode(document.getElementById('copiar3'));
              window.getSelection().removeAllRanges();
              window.getSelection().addRange(r);
              try {
                document.execCommand('copy');
                window.getSelection().removeAllRanges();
                console.log('Successfully copy text:' + r);
                setNotificationType(19);
              } catch (err) {
                console.log('Unable to copy!');
              }
            }} >
            <div className={styles.copiarTop}>
              COMPROVANTE (clica para copiar)
            </div>
            {(() => {
              const origin = window.location.hostname === 'localhost'
                ? `${window.location.protocol}//${window.location.hostname}:${window.location.port}`
                : `${window.location.protocol}//${window.location.hostname}`;

              const linkAcesso = `${origin}/parceirosPage/${comprovanteUsuarioParceiro}`;
              return (
                <p id='copiar3' className={styles.copiarText}>
                  🎉 Bem-vindo ao Programa de Parceiros Agiliza Visto!<br /><br />

                  Acesse sua área exclusiva pelo link abaixo:<br />
                  Link de acesso: {linkAcesso}<br /><br />

                  📊 No seu painel, você poderá acompanhar em tempo real:<br />
                  - Quantos acessos você gerou<br />
                  - Quantas vendas foram feitas através do seu link<br />
                  - O valor das suas comissões acumuladas<br /><br />

                  💵 As comissões são pagas duas vezes ao mês:<br />
                  - Todo dia 15<br />
                  - Todo último dia do mês<br /><br />

                  🔒 Seus dados de cadastro:<br />
                  Nome: {comprovanteNomeParceiro}<br />
                  Contato: {comprovanteContatoParceiro}<br />
                  CPF: {comprovanteCpfParceiro}<br />
                  Chave PIX: {comprovantePixParceiro}<br />
                  Usuário: {comprovanteUsuarioParceiro}<br />
                </p>
              );
            })()}


          </div>
          : <></>
        }
        <div className={styles.divisor}></div>
        <div className={styles.usersListContainer}>
          {filteredDataParceiros.map((user, index) => {
            return (
              <div key={user.id} className={styles.userContainer}>
                <div style={{ position: 'absolute', right: '10px', top: '10px', color: 'green', fontWeight: 'bold' }}>
  {user.contaSite}
</div>

                <div className={styles.userContainer2}>
                  <div className={styles.onOffIconContainer}>
                    <div>
                      <p className={styles.icon}>{user.status}</p>
                    </div>
                  </div>
                  <div className={styles.loginContainer}>
                    <p>{user.nomeParceiro}</p>
                  </div>
                  <div className={styles.iconeslat}>
                  </div>
                </div>
                <div className={styles.userContainer1}>
                  <div className={styles.obsContainer}>
                    <p>{user.contatoParceiro}</p>
                  </div>
                  <div className={styles.obsContainer}>
                    <p>{user.obsParceiro}</p>
                  </div>
                  <div className={styles.obsContainer}>
                    <p>{user.usuarioParceiro}</p>
                  </div>

                  {/* AQUI VAI O BOTÃO DE DETALHES */}
                  <div style={{ marginTop: '10px' }}>
                    <button
                      onClick={() => {
                        const origin = window.location.hostname === 'localhost'
                          ? `${window.location.protocol}//${window.location.hostname}:${window.location.port}`
                          : `${window.location.protocol}//${window.location.hostname}`;

                        const uniqueLink = `${origin}/parceirosPage/${user.usuarioParceiro}`;
                        window.location.href = uniqueLink;
                      }}
                      className={styles.botaoDetalhesParceiro}
                    >

                      Ver Detalhes
                    </button>
                  </div>
                  {/* FIM DO BOTÃO */}

                </div>
              </div>

            );
          })}
        </div>
      </div>
    </div>
  );
}

export default Parceiros;